
export default function Headings({text}) {
    return(
        <p className="text-center text-3xl font-bold">{text}</p>
    )
}